<template>
  <v-btn
    v-bind="activatorProps"
    :icon="iconName"
    size="30"
    :text="title"
    class="ma-1 ml-15"
    variant="outlined"
    @click="isActive = true"
  ></v-btn>
  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="300">
        <v-form @submit.prevent enctype="multipart/form-data" ref="form">
          <v-text-field
            v-model="formData.fullname"
            :rules="fullnameRules"
            label="الاسم"
          ></v-text-field>
          <v-text-field
            v-model="formData.email"
            :rules="emailRules"
            label="البريد الالكتروني"
          ></v-text-field>
          <v-text-field
            v-model="formData.phone"
            :rules="phoneRules"
            label="الجوال"
          ></v-text-field>
          <v-text-field
            v-model="formData.password"
            :rules="[
              mod == 'add' ? passwordRules.required : passwordRules.optional,
            ]"
            label="كلمة المرور"
          ></v-text-field>
          <v-radio-group v-model="formData.status">
            <v-row>
              <v-col cols="12" sm="6">
                <v-radio label="فعال" value="active"></v-radio>
              </v-col>
              <v-col cols="12" sm="6">
                <v-radio label="محظور" value="blocked"></v-radio>
              </v-col>
            </v-row>
          </v-radio-group>

          <v-row>
            <v-col cols="12" sm="6">
              <v-checkbox
                label="مشرف أعلى"
                value="superadmin"
                v-model="formData.roles"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6">
              <v-checkbox
                label="مشرف"
                value="admin"
                v-model="formData.roles"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6">
              <v-checkbox
                label="محاسب"
                value="accountant"
                v-model="formData.roles"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6">
              <v-checkbox
                label="مراقب"
                value="observer"
                v-model="formData.roles"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-form>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="حفظ" @click="save"></v-btn>

        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["saveFunction", "item", "mode", "iconName"],
  data() {
    return {
      isActive: false,
      selectedRoles: [],
      formData: {
        fullname: "",
        email: "",
        phone: "",
        password: "",
        status: "",
        roles: [],
        rolesNames: [],
      },
      fullnameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      emailRules: [(v) => !!v || "Email is required"],
      phoneRules: [(v) => !!v || "Phone is required"],
      passwordRules: {
        required: (v) => !!v || "Password is required",
        optional: () => true, // Always returns true, making the field optional
      },
    };
  },
  methods: {
    async validate() {
      const { valid } = await this.$refs.form.validate();

      if (valid) alert("Form is valid");
    },
    reset() {
      this.$refs.form.reset();
    },
    async save() {
      const { valid } = await this.$refs.form.validate();

      if (valid) {
        this.saveFunction(this.formData, this.mode);

        this.isActive = false;
      }
    },
    close() {
      this.isActive = false;
    },
    checkChanged() {
      console.log("ccc", "check changed");
    },
  },
  watch: {
    isActive(value) {
      if (value) {
        this.formData.roles = [];
        console.log("cxcxC", this.item);
        if (this.mode == "edit") {
          this.formData = { ...this.item };
        }

        this.formData.roles = this.formData.roles?.map((v) => v.rolename);
      }
    },
  },
  computed: {
    title() {
      if (this.mode == "add") return "إضافة مستخدم";
      return "تعديل مستخدم";
    },
  },
};
</script>
